import { SCATTERPLOT_CHART, BAR_CHART, HISTOGRAM_CHART, LINE_CHART, PREDICTION, PARALLEL_COORDINATES_CHART} from "../Canvas/Constants";
import { BrushingDataSet, brushingDataset} from "../../Globals/Globals";
import * as aggregation from "../aggregation/countAggregation";
import {HscatterPlotElements, HbarChartElements, HbarChartResizeYAxis, HhistogramElements, HbarChartElementsCount, HLineChartResizeYAxis, HbarChartElementsAvg} from '../Brushing/HistogramBrushElements'
import {findMaxForBarChart, lineChartBrushElements, removeBrushElements, histogramBrushElements, parallelCoordinatesBrushElements, scatterPlotElements} from '../Brushing/BrushingElements'
import * as d3 from "d3";
import {PREDICTION_COLOR,REALDATA_COLOR,BRUSHING_COLOR,NO_PREDICTION_COLOR} from '../../Globals/ColorConstants'
import {SbarChartElements, SremoveScatterPlotBrushElements} from '../Brushing/ScatterPlotBrushElements'
import { type } from "os";

export function histogramBrush(ggraphbrushEnable, currentID, brushingPointsHistogramArray, brushingDataset: BrushingDataSet){

    
    if(ggraphbrushEnable == 0 || ggraphbrushEnable == 1)
    {
        if(brushingPointsHistogramArray.length>0)
        {
        var xaxis = brushingDataset.getBrushingHistogramAxis().xaxis 
        var yaxis = brushingDataset.getBrushingHistogramAxis().yaxis
        var actualDataset = brushingDataset.getActualID(currentID)
        var datasetwise = aggregation.allValues
        var datasetIds = []
        var indexes = []
     
        brushingPointsHistogramArray.forEach(brushingPointsHistogram => {
            var startIndex
            var endIndex 
         
            if(brushingPointsHistogram.type == PREDICTION)
            {
                var arrayID
                for(var key in actualDataset.thresholdvaluesMap){
                    if(actualDataset.thresholdvaluesMap[key][0] == brushingPointsHistogram.startX && 
                        actualDataset.thresholdvaluesMap[key][1] == brushingPointsHistogram.endX)
                        {
                            arrayID = key
                        }

                }
                if (arrayID != undefined)
                {
                    startIndex = arrayID
                    endIndex = arrayID
                }
                
            }
            else
            {
                for(let l=0;l<brushingPointsHistogram.thresholds.length;l++)
                {
                    if( Math.round(brushingPointsHistogram.startX) > actualDataset.thresholdvaluesMap[l][0] && 
                        Math.round(brushingPointsHistogram.startX) <= actualDataset.thresholdvaluesMap[l][1])
                        {
                            startIndex = l
                        }
                    if( Math.round(brushingPointsHistogram.endX) > actualDataset.thresholdvaluesMap[l][0] && 
                        Math.round(brushingPointsHistogram.endX) <= actualDataset.thresholdvaluesMap[l][1])
                        {
                            endIndex = l
                        }
               
                   
                }
            }
           
            if(startIndex==undefined || endIndex ==undefined)
            {
                
            }
            else
            {
                for(let k=startIndex;k<=endIndex;k++)
                {    
                    indexes.push(k)
                    datasetIds = datasetIds.concat(brushingPointsHistogram.thresholdArrayIds[k])
                }
            }

        })
     
        console.log("startXElementstartXElement",datasetIds)
       
        
        removeBrushElements(currentID)
        brushingDataset.getActualMap().forEach(function(datasetValue, datasetKey, map) {
            
            
            if(datasetKey != currentID)
            {

                if (datasetValue.type == SCATTERPLOT_CHART)
                {   
                  
                    scatterPlotElements([],datasetKey)
                                      
                    scatterPlotElements(datasetIds,datasetKey)
                    
                }
                else if (datasetValue.type == HISTOGRAM_CHART)
                {       
    
                       histogramBrushElements(datasetValue.xaxis,datasetKey, datasetIds, datasetValue)     

                }
                else if (datasetValue.type == BAR_CHART)
                {   
                        var maxValue = findMaxForBarChart(datasetIds, 
                            datasetValue.linearXScale, 
                            datasetValue.linearYScale, 
                            datasetValue.xaxis, 
                            datasetValue.yaxis,
                            datasetValue, datasetKey)
                        console.log('maxValuebrushingPointsHistogramArray',maxValue)   
                }
                else if (datasetValue.type == LINE_CHART) {

                    lineChartBrushElements(datasetIds, datasetKey, datasetValue) 
                }
                else if (datasetValue.type == PARALLEL_COORDINATES_CHART) {

                    parallelCoordinatesBrushElements(datasetIds, datasetKey, datasetValue) 
                }
            }
            });
        }
    }
    else
    {   
        removeBrushElements(currentID)
    }
    
}